<template>
  <div class="wraper">
    <h3>Входящий вебхук</h3>
    <v-overflow-btn
      class="my-3"
      @input="type_integration"
      :items="arr_type"
      label="Вид входящего вебхука"
      height="50"
      item-value="type"
      item-text="name"
      v-model="data_local.bitrix.type"
      hide-details
    ></v-overflow-btn>
    <div v-if="data_local.bitrix.type">
      <div class="subtitle">Rest api</div>
      <v-text-field
        hide-details
        height="50"
        v-model="data_local.bitrix.token"
        @input="input"
        placeholder="url"
      ></v-text-field>
    </div>

    <div
      v-if="
        data_local.bitrix.type === arr_type[0].type ||
        data_local.bitrix.type === arr_type[1].type
      "
    >
      <div class="subtitle mt-3">Параметры</div>
      <div
        v-for="(option, key) of data_local.bitrix.options"
        :key="key"
        class="block_input_param"
      >
        <v-text-field
          class="block_input_param__options"
          :readonly="option.readonly"
          hide-details
          height="40"
          v-model="option.option"
          @input="input"
          placeholder="option"
        ></v-text-field>
        <div class="block_input_param__value">
          <v-text-field
            :readonly="option.readonly"
            class="ml-5"
            hide-details
            height="40"
            v-model="option.value"
            @input="input"
            placeholder="value"
          ></v-text-field>
          <div
            v-if="!option.required"
            class="delete_icon"
            @click="deleteOption(key)"
          >
            <Icon name="delete" />
          </div>
        </div>
      </div>
    </div>

    <div
      class="add_pram"
      v-if="
        data_local.bitrix.type === arr_type[0].type ||
        data_local.bitrix.type === arr_type[1].type
      "
    >
      <v-overflow-btn
        class="ma-0 pa-0 block_input_param__options mr-4"
        :items="optionsFilter"
        label="Параметр"
        height="40"
        item-value="text"
        v-model="addOption"
        hide-details
      ></v-overflow-btn>
      <Icon name="blue_plus" />
      <div class="add_pram__btn" @click="add_option()">Добавить параметр</div>
    </div>

    <button
      v-if="data_local.bitrix.type === 'leadAdd'"
      type="button"
      class="test-webhook-btn"
      :disabled="!data_local.bitrix.token"
      @click="openBitrixTest"
    >
      Проверить вебхук
    </button>

    <div
      v-if="testDialog"
      class="webhook-test-overlay"
      @click.self="closeBitrixTest"
    >
      <div class="webhook-test-modal">
        <v-card class="test-card">
          <div class="test-header">
            <div>
              <div class="test-title">Проверка отправки в Битрикс24</div>
              <div class="test-subtitle">Проверьте данные перед отправкой</div>
            </div>

            <button
              type="button"
              class="test-close"
              aria-label="Закрыть проверку"
              :disabled="testSending"
              @click="closeBitrixTest"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true" focusable="false">
                <path d="M6 6l12 12M18 6L6 18" />
              </svg>
            </button>
          </div>

          <div class="test-content">
            <div class="test-info-card" v-if="testRecipient">
              <div class="test-info-label">Получатель</div>
              <div class="test-info-value">{{ testRecipient }}</div>
            </div>
            <div class="test-info-card" v-if="testDisplayFields.length">
              <div class="test-info-label">Данные тестового лида</div>
              <dl class="test-fields">
                <div v-for="(field, index) in testDisplayFields" :key="index">
                  <dt>{{ field.name }}</dt>
                  <dd>{{ field.value }}</dd>
                </div>
              </dl>
            </div>
            <div v-else class="test-info-card">Добавьте поля лида в настройках блока.</div>
            <div v-if="testResult" class="test-result" :class="{ 'test-result--error': !testResult.ok }" role="status">
              <div class="test-result-title">{{ testResult.ok ? 'Отправка выполнена' : 'Отправка не выполнена' }}</div>
              <div class="test-result-message">{{ testResult.message }}</div>
            </div>
          </div>

          <div class="test-actions">
            <button
              type="button"
              class="test-send-btn"
              :disabled="testSending || !testDisplayFields.length || !testRecipient"
              @click="sendBitrixTest"
            >
              {{ testSending ? 'Отправляем...' : 'Отправить в Битрикс24' }}
            </button>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/SetIcon';
export default {
  name: 'IntegrationBitrix24',
  props: ['data', 'edit_callback'],
  components: { Icon },
  data() {
    return {
      data_local: {
        bitrix: {
          type: '',
          token: '',
          options: [],
        },
      },
      arr_type: [
        { name: 'Создание карточки', type: 'leadAdd' },
        { name: 'Перемещение карточки', type: 'leadMove' },
      ],
      arr_options: {
        Phone: {
          option: 'PHONE',
          value: '{{ phone }}',
          readonly: true,
          required: false,
        },
        Title: { option: 'TITLE', value: '', readonly: false, required: false },
        'Stage ID': {
          option: 'STAGE_ID',
          value: '',
          readonly: false,
          required: false,
        },
        'Lead ID': {
          option: 'LEAD_ID',
          value: '',
          readonly: false,
          required: false,
        },
        'Свое поле': {
          option: '',
          value: '',
          readonly: false,
          required: false,
        },
      },
      addOption: '',
      testDialog: false,
      testSending: false,
      testPayload: {},
      testResult: null,
    };
  },
  computed: {
    testRecipient() {
      try { return new URL(this.data_local.bitrix.token).host; } catch (_) { return ''; }
    },
    testDisplayFields() {
      const labels = {
        PHONE: 'Телефон', EMAIL: 'Email', TITLE: 'Название лида', NAME: 'Имя',
        LAST_NAME: 'Фамилия', SECOND_NAME: 'Отчество', ADDRESS: 'Адрес',
        ADDRESS_CITY: 'Город', ADDRESS_REGION: 'Регион', COMMENTS: 'Комментарий',
        COMPANY_TITLE: 'Название компании', SOURCE_DESCRIPTION: 'Источник',
        STAGE_ID: 'Стадия', STATUS_ID: 'Статус', LEAD_ID: 'Лид', ASSIGNED_BY_ID: 'Ответственный',
      };
      let customIndex = 0;
      return Object.entries(this.testPayload.fields || {}).map(([key, value]) => {
        const technicalName = /^[A-Z][A-Z0-9_]*$/i.test(key);
        const name = labels[key] || (technicalName
          ? `${/^UF_/i.test(key) ? 'Пользовательское' : 'Дополнительное'} поле ${++customIndex}` : key);
        return {
          name,
          value: ['STAGE_ID', 'STATUS_ID', 'LEAD_ID', 'ASSIGNED_BY_ID'].includes(key)
            ? 'Указано в настройках' : this.formatBitrixTestValue(value),
        };
      });
    },
    optionsFilter() {
      let userOption = [];
      for (let option of this.data_local.bitrix.options) {
        userOption.push(option.option);
      }
      let allOptions = Object.keys(this.arr_options);

      if (userOption.length) {
        for (let use of userOption) {
          let idx = allOptions.findIndex((el) => {
            if (el !== 'Свое поле') {
              // console.log('совпадение', el)
              return el.toLowerCase() === use.toLowerCase();
            } else {
              // console.log('Найдено Свое поле')
              return false;
            }
          });

          if (idx > -1) {
            allOptions.splice(idx, 1);
          }
        }
      }
      return allOptions;
    },
  },
  methods: {
    closeBitrixTest() {
      if (!this.testSending) this.testDialog = false;
    },
    formatBitrixTestValue(value) {
      if (value === null || value === undefined || value === '') return 'Не заполнено';
      if (typeof value === 'boolean') return value ? 'Да' : 'Нет';
      if (Array.isArray(value)) return value.map((item) => this.formatBitrixTestValue(item)).join(', ');
      if (typeof value === 'object') return 'VALUE' in value ? this.formatBitrixTestValue(value.VALUE) : 'Данные передаются';
      return String(value);
    },
    openBitrixTest() {
      const testLeadFields = {
        city: 'Москва',
        first_name: 'Иван',
        last_name: 'Петров',
        middle_name: 'Иванович',
      };

      const fields = {};

      for (const option of this.data_local.bitrix.options) {
        const fieldName = String(option.option || '').trim();

        if (!fieldName) {
          continue;
        }

        if (fieldName === 'PHONE') {
          fields.PHONE = [
            {
              VALUE: '79990000000',
              VALUE_TYPE: 'WORK',
            },
          ];

          continue;
        }

        let value = option.value;

        if (typeof value === 'string') {
          value = value
            .replaceAll('{{ phone }}', '79990000000')
            .replaceAll('{{phone}}', '79990000000');

          const leadFieldMatch = value.match(/^\{([^{}]+)\}$/);

          if (leadFieldMatch) {
            const leadFieldName = leadFieldMatch[1];

            value =
              testLeadFields[leadFieldName] !== undefined
                ? testLeadFields[leadFieldName]
                : `Тестовое значение ${leadFieldName}`;
          }
        }

        fields[fieldName] = value;
      }

      this.testPayload = {
        fields,
      };

      this.testResult = null;
      this.testDialog = true;
    },

    sendBitrixTest() {
      if (this.testSending || !this.testDisplayFields.length || !this.testRecipient) return;
      this.testSending = true;
      this.testResult = null;

      this.$http.post(
        'integrations/test_bitrix_send',
        {
          bitrix: this.data_local.bitrix,
          payload: this.testPayload,
        },
        (response) => {
          this.testSending = false;
          const legacyData = response && response.data;
          const ok = Boolean(response && response.ok && !(legacyData && legacyData.error));
          const legacy = response && ('data' in response || 'payload' in response || 'status' in response);
          this.testResult = {
            ok,
            message: response && !legacy && response.message
              ? response.message
              : ok ? 'Битрикс принял тестовый запрос. Проверьте лид на портале.'
                : 'Проверьте настройки вебхука и значения полей в Битрикс24.',
          };
        },
      );
    },
    input() {
      this.edit_callback(this.data_local);
      return true;
    },
    type_integration() {
      switch (this.data_local.bitrix.type) {
        case 'leadAdd':
          this.data_local.bitrix.options = [
            {
              option: 'PHONE',
              value: '{{ phone }}',
              readonly: true,
              required: true,
            },
            { option: 'TITLE', value: '', readonly: false, required: true },
          ];
          break;

        case 'leadMove':
          this.data_local.bitrix.options = [
            {
              option: 'LEAD_ID',
              value: '{{ lead_id }}',
              readonly: true,
              required: true,
              skip: true,
            },
          ];
          break;

        default:
          this.data_local.bitrix.options = [];
          break;
      }
    },
    add_option() {
      if (this.addOption) {
        this.data_local.bitrix.options.push({
          ...this.arr_options[this.addOption],
        });
        this.addOption = '';
      }
    },
    deleteOption(key) {
      this.data_local.bitrix.options.splice(key, 1);
    },
  },
  watch: {
    data: function (val) {
      this.data_local = val;
    },
  },
  mounted() {
    this.data_local = this.data;
  },
};
</script>

<style scoped>
.wraper {
  max-width: 600px;
  margin: 0 auto;
  width: 600px;
}

.add_pram {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-top: 15px;
  margin-bottom: 40px;
}

.add_pram__btn {
  color: #4b5eff;
  margin-left: 10px;
}

.delete_icon {
  width: 40px;
  height: 40px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  margin-left: 16px;
  border: 1px solid #4b5eff;
  border-radius: 8px;
  display: flex;
}

.block_input_param {
  display: flex;
  margin-bottom: 15px;
}

.block_input_param__value {
  width: 61%;
  display: flex;
}
.subtitle {
  text-align: left;
  padding-left: 8px;
}

@media (max-width: 650px) {
  .wraper {
    width: 100%;
  }
}
.test-webhook-btn {
  padding: 11px 18px;
  color: #fff;
  background: #4b5eff;
  border: 1px solid #4b5eff;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
}

.test-webhook-btn:hover {
  background: #3949e8;
}

.test-webhook-btn:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.webhook-test-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.45);
}

.webhook-test-modal {
  position: relative;
  z-index: 10000;
  width: 650px;
  max-width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  background: #fff;
  border-radius: 16px;
  text-align: left;
}

.test-card {
  overflow: hidden;
  border-radius: 16px !important;
  box-shadow: none !important;
}

.test-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 26px 8px;
}

.test-title {
  color: #2b2d33;
  font-size: 18px;
  font-weight: 600;
}

.test-subtitle {
  margin-top: 4px;
  color: #8b8d98;
  font-size: 14px;
}

.test-close {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  padding: 0;
  color: #676a76;
  background: transparent;
  border: 0;
  border-radius: 8px;
  cursor: pointer;
}

.test-close:hover:not(:disabled) { color: #4b5eff; background: #f3f4ff; }
.test-close:focus-visible { outline: 2px solid #4b5eff; outline-offset: 2px; }
.test-close:disabled { opacity: 0.45; cursor: default; }

.test-content {
  padding: 0 26px;
}

.test-call-info {
  padding: 14px 50px;
  margin-bottom: 18px;
  text-align: center;
  background: #f3f4ff;
  border: 1px solid #dfe2ff;
  border-radius: 10px;
}

.test-call-label,
.test-info-label {
  color: #8b8d98;
  font-size: 13px;
  font-weight: 600;
}

.test-call-value {
  margin-top: 3px;
  color: #2b2d33;
  font-weight: 600;
}

.test-info-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 12px;
  margin-bottom: 20px;
}

.test-info-card {
  min-width: 0;
  padding: 14px 16px;
  background: #f8f9fc;
  border: 1px solid #e5e7ef;
  border-radius: 10px;
  margin-top: 12px;
  font-size: 14px;
}

.test-info-value {
  margin-top: 7px;
  overflow-wrap: anywhere;
  color: #2b2d33;
  font-size: 14px;
}

.test-payload-title {
  margin-bottom: 8px;
  color: #2b2d33;
  font-size: 15px;
  font-weight: 700;
}

.test-payload {
  max-height: 260px;
  padding: 18px;
  overflow: auto;
  color: #dfe3ff;
  background: #25283b;
  border-radius: 12px;
  font-size: 13px;
  line-height: 1.6;
  text-align: left;
  white-space: pre-wrap;
  word-break: break-word;
}

.test-result {
  min-width: 0;
  padding: 14px 16px;
  margin-top: 16px;
  overflow: hidden;
  background: #f6fff9;
  border: 1px solid #bde8cb;
  border-radius: 10px;
}

.test-result pre {
  width: 100%;
  max-height: 220px;
  margin: 10px 0 0;
  padding: 12px;
  overflow: auto;
  color: #2b2d33;
  background: #fff;
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.5;
  text-align: left;
  white-space: pre-wrap;
  word-break: break-word;
}

.test-actions {
  display: flex;
  justify-content: center;
  gap: 10px;
  padding: 20px 26px 26px;
  background: #fff;
}

.test-cancel-btn,
.test-send-btn {
  padding: 11px 18px;
  border-radius: 8px;
  font-weight: 600;
}

.test-cancel-btn {
  color: #4b5eff;
  background: #fff;
  border: 1px solid #dfe2ff;
}

.test-send-btn {
  color: #fff;
  background: #4b5eff;
  cursor: pointer;
}

.test-send-btn:hover:not(:disabled) { background: #3949e8; }
.test-fields { margin: 8px 0 0; }
.test-fields > div {
  display: grid;
  grid-template-columns: minmax(110px, 35%) minmax(0, 1fr);
  gap: 12px;
  padding: 6px 0;
  font-size: 14px;
  line-height: 1.5;
}
.test-fields dt { color: #808185; }
.test-fields dd { margin: 0; overflow-wrap: anywhere; }
.test-result-title { font-size: 15px; font-weight: 600; }
.test-result-message { margin-top: 8px; line-height: 1.5; font-size: 14px; }
.test-result--error { background: #fff3f3; border-color: #ffd0d0; }

.test-send-btn:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

@media (max-width: 650px) {
  .webhook-test-overlay { padding: 12px; }
  .test-header { padding: 18px 18px 8px; }
  .test-content { padding: 0 18px; }
  .test-actions { padding: 18px; }
  .test-fields > div { grid-template-columns: minmax(0, 1fr); gap: 2px; }
}
</style>
